import PropTypes from 'prop-types';
import classnames from 'classnames';

import { ReactComponent as AddStrokeSVG } from '../../icons/add-stroke.svg';

const AsideItem = ({
  label,
  active,
  primaryAction,
  search,
  secondaryAction,
  count,
  subMenu,
}) => {
  const className = classnames({
    active: active,
    'th-nav-list-submenu': subMenu,
  });

  const primaryPath = search
    ? `${primaryAction}?${new URLSearchParams(search)}`
    : primaryAction;

  return (
    <li id={label} className="relative">
      <a className={className} href={primaryPath}>
        <span className="th-nav-viewname">
          {label}
          {count > 0 && (
            <span key={primaryAction} className="th-badge-count">
              {count}
            </span>
          )}
        </span>
      </a>
      {secondaryAction && (
        <a
          href={secondaryAction}
          className="th-secondary-action th-nav-new-post"
        >
          <span>
            <AddStrokeSVG />
          </span>
        </a>
      )}
    </li>
  );
};

AsideItem.propTypes = {
  label: PropTypes.string,
  active: PropTypes.bool,
  primaryAction: PropTypes.string,
  secondaryAction: PropTypes.string,
  count: PropTypes.number,
  subMenu: PropTypes.bool,
};

export default AsideItem;
